var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isShowInfoBanner)?_c('div',{staticClass:"p-2 position-sticky top-0 z-3",style:({ background: _vm.background })},[_c('p',{staticClass:"mb-0",style:({ color: _vm.fontColor }),domProps:{"innerHTML":_vm._s(_vm.text)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }